import SuperRepository from '../superRepository'

export default new (class PartnerDomainRepository extends SuperRepository {
  baseUri() {
    return 'partner_domain'
  }
})()